import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { Container } from "@mui/material";

//-------------------------------------components
import { Header, Footer } from "../components";
import ScrollTopProvider from '../components/provider';

//-------------------------------------pages
import {
  LandingPage,
  DoctorsPage,
  DepartmentPage,
  DoctorPage,
  VisitPage,
  ProfilePage,
  ProfileDetails,
  UserHistory,
  UserTransactions,
  Wallet,
  AboutUsPage,
  ContanctUsPage,
  RulesPage,
  CanselRulesPage,
  FactorPage,
  NotfoundPage,
  ServerErrPage,
  FailedPaymentPage,
  SubmitPaymentPage,
} from "../pages";

export default function Index() {
  return (
    <Router>
      <Header />
      <ScrollTopProvider>
        <div className="container" style={{ minHeight: "90vh" }}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/doctors" element={<DoctorsPage />} />
            <Route path="/department/:id" element={<DepartmentPage />} />
            <Route path="/doctors/:id" element={<DoctorPage />} />
            <Route path="/visit/:doctorid/:id" element={<VisitPage />} />
            <Route path="/aboutus" element={<AboutUsPage />} />
            <Route path="/contactus" element={<ContanctUsPage />} />
            <Route path="/rules" element={<RulesPage />} />
            <Route path="/cancelrules/:id" element={<CanselRulesPage />} />
            <Route path="/factor/:doctorid/:id" element={<FactorPage />} />
            <Route path="/servererror" element={<ServerErrPage />} />
            <Route path="/paymentresult" element={<FailedPaymentPage />} />
            <Route path="/payment-submit" element={<SubmitPaymentPage />} />

            <Route path="/profile" element={<ProfilePage />}>
              <Route path="" element={<ProfileDetails />} />
              <Route path="history" element={<UserHistory />} />
              <Route path="transactions" element={<UserTransactions />} />
              <Route path="wallet" element={<Wallet />} />

              {/* 
            <Route path="travelhistory" element={<TravelHistoryPage />} />
            <Route path="passengers" element={<PassengersListPage />} />
            <Route path="transactions" element={<TransactionListPage />} />
            <Route path="supportlist" element={<SupportListPage />} />
            <Route path="bookmarks" element={<BookmarkPage />} /> */}
            </Route>

            <Route path="*" element={<NotfoundPage />} />
          </Routes>
        </div>
      </ScrollTopProvider>
      <Footer />
    </Router>
  );
}
